module.exports = __webpack_public_path__ + "static/climateneutralcertified-c1858d7b40a05b9765fbde8d154128f6.png";